import { PaymentStatus, PositionNumber, PositionNumberType } from 'api/common/constants'
import { PositionResponse } from 'api/common/responses'
import { Position } from 'api/common/types'
import { getContractDocument, getSummaryDocument } from 'api/document'
import { positionsAPI } from 'api/position'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'

const SceneComponent: React.FC = () => {
  const [positions, setPositions] = React.useState<Position[]>([])

  /**
   * 「概要書面ダウンロード」ボタン
   */
  const onClickSummary = () => {
    getSummaryDocument((response) => {
      const objUrl = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }))
      downloadDocument(objUrl, '概要書面.pdf')
    })
  }

  // TODO: Zipでダウンロードはペンディング
  // const onClickContractAll = () => {
  //   getContractDocumentAll((response) => {
  //     const objUrl = window.URL.createObjectURL(new Blob([response], { type: 'application/zip' }))
  //     downloadDocument(objUrl, '契約書面.zip')
  //   })
  // }

  const getContractDocumentName = (positionNumber: PositionNumberType) => {
    const positionName = positionNumber === PositionNumber.MainPosition ? 'メインポジション' : `サブポジション${positionNumber - 1}`
    return `${positionName}契約書面`
  }

  const onClickContract = (positionNumber: PositionNumberType) => {
    getContractDocument(positionNumber, (response) => {
      const objUrl = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }))
      downloadDocument(objUrl, `${getContractDocumentName(positionNumber)}.pdf`)
    })
  }

  React.useEffect(() => {
    positionsAPI((response: PositionResponse) => {
      const positions = response.positions.filter((position) => position.paymentStatus === PaymentStatus.Paid && !position.isChangedAssignment)
      setPositions(positions)
    })
  }, [])

  const downloadDocument = (objUrl: string, filename: string) => {
    const link = document.createElement('a')
    link.href = objUrl
    link.download = filename
    link.click()
  }
  return (
    <>
      <Header title="書類管理" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <Button variant="primary" className="w-100 py-4" href="/assets/概要書面注文書.pdf" target="_blank">
              概要書面注文書
            </Button>
          </div>
          <div className="mt-5">
            <Button variant="primary" className="w-100 py-4" onClick={onClickSummary}>
              概要書面ダウンロード
            </Button>
          </div>
          {positions.map((position, index) => (
            <div className="mt-5" key={index}>
              <Button variant="primary" className="w-100 py-4" onClick={() => onClickContract(position.positionNumber)}>
                {getContractDocumentName(position.positionNumber)}ダウンロード
              </Button>
            </div>
          ))}
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
